<script setup>
import BottomNav from './BottomNav.vue';

defineProps({ active: { type: String, default: '' }, nav: { type: Boolean, default: true }, scrollable: Boolean });
</script>

<template>
  <section class="mobile-screen" :class="{ 'no-nav': !nav, scrollable }">
    <slot />
    <BottomNav v-if="nav" :active="active" />
  </section>
</template>
